import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { SlideMenuModule } from 'primeng/slidemenu';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

import { HighchartsChartModule } from 'highcharts-angular';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AiAssistantComponent } from './ai-assistant/ai-assistant.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ComponentEditGuard } from './component-edit-guard.service';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { FaqComponent } from './document-viewer/legal/faq/faq.component';
import { FormInputFieldErrorComponent } from './form-input-field-error/form-input-field-error.component';
import { ImageAssetComponent } from './image-asset/image-asset.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { KeyFilterModule } from 'primeng/keyfilter';
import { PrivacyComponent } from './document-viewer/legal/privacy/privacy.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SectionHostComponent } from './section-host/section-host.component';
import { SectionLoadingIndicatorComponent } from './section-loading-indicator/section-loading-indicator.component';
import { SelectAlbumDialogComponent } from './select-album-dialog/select-album-dialog.component';
import { SelectAlbumsDialogComponent } from './select-albums-dialog/select-albums-dialog.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MemberListDialogComponent } from './member-list-dialog/member-list-dialog.component';
import { SelectCategoriesDialogComponent } from './select-categories-dialog/select-categories-dialog.component';
import { SelectDocumentPdfComponent } from './select-pdf/select-document-pdf/select-document-pdf.component';
import { SelectImagesComponent } from './select-images/select-images.component';
import { SelectPDFComponent } from './select-pdf/select-pdf.component';
import { TermsComponent } from './document-viewer/legal/terms/terms.component';
import { WaitingIndicatorComponent } from './waiting-indicator/waiting-indicator.component';
import { SelectStockImageComponent } from './select-stock-image/select-stock-image.component';

@NgModule({
	declarations: [
		AiAssistantComponent,
		DocumentViewerComponent,
		FaqComponent,
		TermsComponent,
		PrivacyComponent,
		FormInputFieldErrorComponent,
		WaitingIndicatorComponent,
		SectionHostComponent,
		SectionLoadingIndicatorComponent,
		ColorPickerComponent,
		ImageAssetComponent,
		MemberListDialogComponent,
		SelectImagesComponent,
		SelectPDFComponent,
		SelectAlbumDialogComponent,
		SelectAlbumsDialogComponent,
		SelectCategoriesDialogComponent,
		SelectDocumentPdfComponent,
  SelectStockImageComponent
	],
	imports: [
		CommonModule,

		FormsModule,
		ReactiveFormsModule,

		FontAwesomeModule,

		ButtonModule,
		CalendarModule,
		CheckboxModule,
		ColorPickerModule,
		DataViewModule,
		DialogModule,
		DropdownModule,
		EditorModule,
		FileUploadModule,
		InputNumberModule,
		InputTextareaModule,
		InputTextModule,
		KeyFilterModule,
		ListboxModule,
		MenubarModule,
		MenuModule,
		MessageModule,
		MessagesModule,
		MultiSelectModule,
		OverlayPanelModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		RadioButtonModule,
		RippleModule,
		SelectButtonModule,
		SlideMenuModule,
		TableModule,
		ToggleButtonModule,
		ToolbarModule,
		TreeModule,
		TreeTableModule,
		HighchartsChartModule,
		PdfViewerModule
	],
	exports: [
		FormsModule,
		ReactiveFormsModule,

		FontAwesomeModule,
		InfiniteScrollModule,

		ButtonModule,
		CalendarModule,
		CheckboxModule,
		ColorPickerModule,
		DataViewModule,
		DialogModule,
		DropdownModule,
		EditorModule,
		FileUploadModule,
		InputNumberModule,
		InputTextareaModule,
		InputTextModule,
		KeyFilterModule,
		ListboxModule,
		MenubarModule,
		MenuModule,
		MessageModule,
		MessagesModule,
		MultiSelectModule,
		OverlayPanelModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		RadioButtonModule,
		RippleModule,
		SelectButtonModule,
		SlideMenuModule,
		TableModule,
		ToggleButtonModule,
		ToolbarModule,
		TreeModule,
		TreeTableModule,

		HighchartsChartModule,

		AiAssistantComponent,
		DocumentViewerComponent,
		FormInputFieldErrorComponent,
		ColorPickerComponent,
		ImageAssetComponent,
		WaitingIndicatorComponent,
		SectionHostComponent,
		SectionLoadingIndicatorComponent,
		MemberListDialogComponent,
		SelectImagesComponent,
		SelectPDFComponent,
		SelectAlbumDialogComponent,
		SelectAlbumsDialogComponent,
		SelectCategoriesDialogComponent
	],
	providers: [
		ComponentEditGuard
	]
})
export class CoreUIModule {}
